var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-card',{attrs:{"title":_vm.$t('reply.enable-new'),"show-back":"","route-url":{name:'owner:instagram-reports'}}}),_c('process-reply',{attrs:{"story":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }